export default "__VITE_ASSET__Cv0X2Wz1__"